import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { apiGet } from "@/shared/api";
import type { paths } from "@/shared/api/generated/schema";
import { useCurrentBoardSlug } from "@/shared/hooks/useCurrentBoardSlug";

type SearchResponse =
  paths["/search"]["get"]["responses"]["200"]["content"]["application/json"];

export type SearchHit = SearchResponse["data"][number];

/**
 * 全文検索フック (post 単位)。
 * クエリ非空のときだけ /search を叩き、post ヒットを返す。
 *
 * NOTE: client.ts の unwrap は { success, data, ... } から data だけを返すため
 * count / query は失われる。UI で必要になったら envelope を保つラッパーへ移行する。
 */
export function useSearch(query: string): UseQueryResult<SearchHit[]> {
  const slug = useCurrentBoardSlug();
  const trimmed = query.trim();

  return useQuery({
    queryKey: ["search", slug, trimmed],
    queryFn: async (): Promise<SearchHit[]> => {
      const params = new URLSearchParams({
        q: trimmed,
        slug,
        limit: "50",
      });
      return apiGet<SearchHit[]>(`/search?${params.toString()}`);
    },
    enabled: trimmed.length > 0,
    staleTime: 30_000,
    retry: 1,
  });
}
